import React, { useState, useEffect, useRef } from "react";
import Modal from "@mui/material/Modal";
import {
  Box,
  List,
  ListItem,
  IconButton,
  Dialog,
  useMediaQuery,
  useTheme,
  MenuItem,
  Menu,
} from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

import "../home/style.css";
import SettingsIcon from "src/images/home/settingsIcon.png";
import { LoginForm } from "src/sections/auth/login";
import useAuth from "src/hooks/useAuth";
import { Link, useParams } from "react-router-dom";
import Register from "src/pages/auth/Register";
import Emailmessage from "src/sections/auth/register/emailMessage";
import { API_COINGECKO } from "src/config";

const Topbar = () => {
  const [values, setValues] = React.useState({});
  const fetchMarketCap = async () => {
    const options = {
      method: "GET",
      headers: {
        accept: "application/json",
        "x-cg-demo-api-key": API_COINGECKO,
      },
    };

    fetch(`https://api.coingecko.com/api/v3/global`, options)
      .then((res) => res.json())
      .then((res) => setValues(res?.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchMarketCap();
    const interval = setInterval(() => {
      fetchMarketCap();
    }, 600000);

    return () => clearInterval(interval);
  }, []);
  const [open, setOpen] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // Reference for the dropdown menu
  const { user, isAdmin } = useAuth();
  const isLoggedIn = !user;

  const handleCloseRegister = () => {
    setOpenRegister(false);
  };
  const handleOpen = () => {
    setOpen(true);
    handleCloseRegister(true);
  };
  const handleClose = () => setOpen(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close the dropdown if the click is outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatLargeNumber = (value) => {
    if (value >= 1e12) {
      return `$${(value / 1e12).toFixed(3)}T`; // Format in trillions
    } else if (value >= 1e9) {
      return `$${(value / 1e9).toFixed(3)}B`; // Format in billions
    } else if (value >= 1e6) {
      return `$${(value / 1e6).toFixed(3)}M`; // Format in millions
    }
    return `$${value}`; // Default for smaller values
  };
  const { uname } = useParams();

  useEffect(() => {
    if (uname) {
      setOpenRegister(true);
    }
  }, [uname]);
  const [emailMessage, setEmailMessage] = useState(false);
  const [openMessage, setOpenMessage] = useState();

  const handleClickOpenMessage = () => {
    setOpenMessage(true);
    setOpenRegister(false);
  };
  const handleCloseMessage = () => {
    setOpenMessage(false);
  };
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleScroll = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const isSubAdmin = localStorage.getItem("isSubAdmin") === "true";

  if (isSubAdmin) {
    const menu_lists = JSON.parse(localStorage.getItem("menu"));
    const [menu] = menu_lists;
    const { path, children } = menu?.items[0] || {};

    if (path.includes("dashboard")) {
      window.location = `${window.origin}${path}`;
      return;
    }
    window.location = `${window.origin}${path}`;
    return;
  }
  return (
    <>
      <Box className="topBar">
        {/* Coin Details Section */}
        <List className="coinDetails">
          {/* <ListItem>
            Coins <span>16,204</span>
          </ListItem>
          <ListItem>
            Exchanges <span>1,912</span>
          </ListItem> */}

          <ListItem>
            Market Cap{" "}
            <span> {formatLargeNumber(values?.total_market_cap?.usd)} </span>{" "}
            <b className="redText">
              <Typography className="countcaption flex items-center">
                {" "}
                <span
                  className={`flex-inline items-center mr-5 ${
                    values?.market_cap_change_percentage_24h_usd > 0
                      ? "greenText"
                      : "redText"
                  }`}
                >
                  <i
                    className={`iconfont1 ${
                      values?.market_cap_change_percentage_24h_usd > 0
                        ? "ri-arrow-up-s-fill"
                        : "ri-arrow-down-s-fill"
                    }`}
                  ></i>
                  {values?.market_cap_change_percentage_24h_usd?.toFixed(1)}%
                </span>
              </Typography>
            </b>
          </ListItem>
          <ListItem>
            24h Vol{" "}
            <span> {formatLargeNumber(values?.total_volume?.usd)} </span>
          </ListItem>

          {/* <ListItem
            onClick={handleMenuOpen}
            sx={{
              cursor: "pointer",

              color: "#0f50e1",
              transition: "background-color 0.3s, color 0.3s",
              "&:hover": {
                color: "#e7be00",
              },
            }}
          >
            C-LIP Products
          </ListItem>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            sx={{
              mt: 1,
              "& .MuiMenu-paper": {
                borderRadius: "12px",
                boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.2)",
                background: "white",
                minWidth: "150px",
              },
            }}
          >
            <MenuItem
              onClick={handleMenuClose}
              sx={{
                "&:hover": { background: "#f5f5f5" },
              }}
            >
              <Link to="/" style={{ textDecoration: "none", color: "black" }}>
                FIP
              </Link>
            </MenuItem>
            <MenuItem
              onClick={handleMenuClose}
              sx={{
                "&:hover": { background: "#f5f5f5" },
              }}
            >
              <Link to="/" style={{ textDecoration: "none", color: "black" }}>
                SIP
              </Link>
            </MenuItem>
            <MenuItem
              onClick={handleMenuClose}
              sx={{
                "&:hover": { background: "#f5f5f5" },
              }}
            >
              <Link to="/" style={{ textDecoration: "none", color: "black" }}>
                IDP
              </Link>
            </MenuItem>
            <MenuItem
              onClick={handleMenuClose}
              sx={{
                "&:hover": { background: "#f5f5f5" },
              }}
            >
              <Link to="/" style={{ textDecoration: "none", color: "black" }}>
                FDP - Coming Soon
              </Link>
            </MenuItem>
          </Menu>
          <ListItem
            sx={{
              cursor: "pointer",
              color: "#0f50e1",
              transition: "background-color 0.3s, color 0.3s",
              "&:hover": {
                color: "#e7be00",
              },
            }}
          >
            Training
          </ListItem>
          <ListItem
            sx={{
              cursor: "pointer",
              color: "#0f50e1",
              transition: "background-color 0.3s, color 0.3s",
              "&:hover": {
                color: "#e7be00",
              },
            }}
          >
            FAQ
          </ListItem>
          <ListItem
            onClick={() => handleScroll("section1")}
            sx={{
              cursor: "pointer",

              color: "#0f50e1",
              transition: "background-color 0.3s, color 0.3s",
              "&:hover": {
                color: "#e7be00",
              },
            }}
          >
            News
          </ListItem>

          <ListItem
            sx={{
              cursor: "pointer",

              color: "#0f50e1",
              transition: "background-color 0.3s, color 0.3s",
              "&:hover": {
                color: "#e7be00",
              },
            }}
          >
            Contact
          </ListItem> */}
          {/* <ListItem>
            Dominance <span>54.7%</span>{" "}
            <b className="greenText">
              <i className="ri-arrow-up-s-fill"></i> 4.4%
            </b>
          </ListItem>
          <ListItem>
            Gas <span>9.714GWEI</span>
          </ListItem> */}
        </List>

        {/* Login and Sign-Up Section */}
        <List className="LoginButnBox">
          {/* <ListItem
            className="settingsBtn"
            onClick={toggleDropdown}
            ref={dropdownRef} // Attach ref to the settings button
          >
            <img src={SettingsIcon} alt="Settings" />
            {isOpen && (
              <div className="settingsdropdownMenu">
                <ul>
                  <li>
                    <span>Language</span>{" "}
                    <span className="setlnge">English</span>
                  </li>
                  <li>
                    <span>Currency</span> <span className="setlnge">USD</span>
                  </li>
                </ul>
              </div>
            )}
          </ListItem> */}
          {/* <ListItem className="signUpBtn" onClick={handleOpen}>
            Login
          </ListItem> */}

          {isLoggedIn ? (
            <ListItem className="signUpBtn" onClick={handleOpen}>
              Login
            </ListItem>
          ) : (
            <>
              {isAdmin ? (
                <Link to="/admin/dashboard/business" className="signUpBtn">
                  Dashboard
                </Link>
              ) : (
                <Link to="/user/dashboard" className="signUpBtn">
                  Dashboard
                </Link>
              )}
            </>
          )}

          {/* <ListItem className="signUpBtn">Sign Up</ListItem> */}
        </List>

        {/* Login Modal */}
        {/* <Modal open={open} handleCloseLogin={handleClose}> */}
        <Dialog open={open} onClose={handleClose}>
          <LoginForm handleCloseLogin={handleClose} />
        </Dialog>

        <Dialog open={openRegister} onClose={handleClose}>
          <Register
            setEmailMessage={setEmailMessage}
            message={handleClickOpenMessage}
            handleClickOpenLogin={handleOpen}
          />
        </Dialog>
        <Dialog
          className="overFlowModalemail"
          fullScreen={fullScreen}
          open={openMessage}
          onClose={handleCloseMessage}
        >
          <Emailmessage
            handleClose={handleClose}
            close={handleCloseMessage}
            emailMessage={emailMessage}
          />
        </Dialog>
      </Box>
    </>
  );
};

export default Topbar;
